/* Trucking Academy theme JS */
(function () {
  /* ta-head is rendered by several sections, so this file can be included more than once per page — run it only once */
  if (window.__taThemeLoaded) return;
  window.__taThemeLoaded = true;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }


  /* ---- Popup (buy box "Open popup" mode; any link to #<popup id> opens it) ---- */
  function taModalOpen(m) {
    if (!m) return;
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ta-modal-open');
    var c = m.querySelector('.ta-modal__close'); if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } }
  }
  function taModalClose(m) {
    if (!m) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-ta-modal].is-open')) document.documentElement.classList.remove('ta-modal-open');
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-ta-modal-open]');
    if (op) { e.preventDefault(); taModalOpen(document.getElementById(op.getAttribute('data-ta-modal-open'))); return; }
    var a = e.target.closest('a[href^="#"]');
    if (a && a.getAttribute('href').length > 1) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && t.hasAttribute('data-ta-modal')) { e.preventDefault(); taModalOpen(t); return; }
    }
    var cl = e.target.closest('[data-ta-modal-close]');
    if (cl) { e.preventDefault(); taModalClose(cl.closest('[data-ta-modal]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var m = document.querySelector('[data-ta-modal].is-open'); if (m) taModalClose(m); }
  });


  /* ---- Product media slider (arrows + dots) and click-to-play videos ---- */
  function taPlayVideo(el) {
    if (!el || el.dataset.taPlaying) return;
    if (el.__taOrig == null) el.__taOrig = el.innerHTML;
    var tpl = el.querySelector('template[data-ta-native]');
    if (tpl) {
      el.dataset.taPlaying = '1';
      el.innerHTML = tpl.innerHTML;
      var vid = el.querySelector('video');
      if (vid) { vid.setAttribute('playsinline', ''); var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    } else {
      var src = el.getAttribute('data-embed');
      if (!src) return;
      el.dataset.taPlaying = '1';
      var f = document.createElement('iframe');
      f.setAttribute('src', src);
      f.setAttribute('title', 'Product video');
      f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      f.setAttribute('allowfullscreen', '');
      el.innerHTML = '';
      el.appendChild(f);
    }
    el.style.cursor = 'default';
  }
  function taResetVideo(scope) {
    if (!scope) return;
    $$('[data-ta-video][data-ta-playing]', scope).forEach(function (el) {
      if (el.__taOrig != null) { el.innerHTML = el.__taOrig; }
      delete el.dataset.taPlaying;
      el.style.cursor = '';
    });
  }
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-ta-video]');
    if (v && !v.dataset.taPlaying) { e.preventDefault(); taPlayVideo(v); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var v = e.target.closest && e.target.closest('[data-ta-video]');
    if (v && !v.dataset.taPlaying && e.target === v) { e.preventDefault(); taPlayVideo(v); }
  });
  /* ---- Banner videos: real video shape + sharp cover image from Vimeo / YouTube ---- */
var taVidMetaCache = null;
function taVidCache() {
if (taVidMetaCache) return taVidMetaCache;
try { taVidMetaCache = JSON.parse(localStorage.getItem('taVidMeta') || '{}') || {}; } catch (err) { taVidMetaCache = {}; }
return taVidMetaCache;
}
function taVidCacheSave() { try { localStorage.setItem('taVidMeta', JSON.stringify(taVidCache())); } catch (err) {} }
function taVidMeta(embed) {
if (!embed) return Promise.resolve(null);
var y = embed.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/);
if (y) {
return new Promise(function (res) {
var i = new Image();
i.onload = function () { res(i.naturalWidth > 120 ? { r: 16 / 9, t: i.src } : { r: 16 / 9, t: 'https://i.ytimg.com/vi/' + y[1] + '/hqdefault.jpg', crop: true }); };
i.onerror = function () { res({ r: 16 / 9, t: 'https://i.ytimg.com/vi/' + y[1] + '/hqdefault.jpg', crop: true }); };
i.src = 'https://i.ytimg.com/vi/' + y[1] + '/maxresdefault.jpg';
});
}
var v = embed.match(/vimeo\.com\/video\/(\d+)/);
if (!v) return Promise.resolve(null);
var c = taVidCache();
if (c['v' + v[1]]) return Promise.resolve(c['v' + v[1]]);
return fetch('https://vimeo.com/api/oembed.json?width=1920&url=' + encodeURIComponent('https://vimeo.com/' + v[1]))
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (j) {
if (!j || !j.width || !j.height) return null;
var m = { r: j.width / j.height, t: j.thumbnail_url || '' };
taVidCache()['v' + v[1]] = m; taVidCacheSave();
return m;
})
.catch(function () { return null; });
}
function taEnhanceBannerVideos(root) {
if (!root || root.__taVidDone) return;
root.__taVidDone = true;
var adaptive = root.classList.contains('ta-pmedia--adaptive');
$$('[data-ta-video][data-embed]', root).forEach(function (el) {
taVidMeta(el.getAttribute('data-embed')).then(function (m) {
if (!m) return;
var slide = el.closest('[data-ta-slide]');
el.setAttribute('data-ta-r', m.r.toFixed(4));
if (slide && adaptive) slide.style.setProperty('--ta-r', m.r.toFixed(4));
if (m.t) {
var img = el.querySelector('.ta-pmedia__img');
if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = m.t; if (m.crop) img.classList.add('is-crop'); }
if (slide) slide.style.setProperty('--ta-bg', 'url("' + m.t + '")');
}
if (root.__taFit) root.__taFit();
});
});
}
function taSlider(root) {
    if (!root || root.__taSlider) return;
    var track = root.querySelector('[data-ta-slider-track]');
    if (!track) return;
    var slides = $$('[data-ta-slide]', track);
    var n = slides.length;
    if (n < 2) return;
    root.__taSlider = true;
    var dots = $$('[data-ta-slider-dot]', root);
    var prev = root.querySelector('[data-ta-slider-prev]');
    var next = root.querySelector('[data-ta-slider-next]');
    var cur = 0, timer;
    var strip = root.querySelector('[data-ta-dotstrip]');
    var mq = window.matchMedia('(max-width: 749px)');
    var MAXDOTS = 5;
var adaptive = root.classList.contains('ta-pmedia--adaptive');
function taRatioOf(s) { var r = parseFloat(s.style.getPropertyValue('--ta-r')); return r > 0 ? r : 16 / 9; }
function fitCap() {
var w = track.clientWidth || root.clientWidth || 1;
var first = w / taRatioOf(slides[0]);
var cap = Math.max(first, Math.min(w * 1.25, window.innerHeight * 0.8));
root.style.setProperty('--ta-cap', Math.round(cap) + 'px');
}
function fitHeight() {
var w = track.clientWidth || 1;
var p = Math.max(0, Math.min(n - 1, track.scrollLeft / w));
var a = Math.floor(p), b = Math.min(n - 1, a + 1), f = p - a;
var h = slides[a].offsetHeight * (1 - f) + slides[b].offsetHeight * f;
if (h > 0) track.style.height = Math.round(h) + 'px';
}
var fitRaf = 0;
function fitSoon() { if (fitRaf) return; fitRaf = requestAnimationFrame(function () { fitRaf = 0; fitHeight(); }); }
if (adaptive) root.__taFit = function () { fitCap(); fitHeight(); };
    function windowDots(i) {
      if (!strip) return;
      if (!mq.matches || n <= MAXDOTS) {
        strip.style.transform = '';
        dots.forEach(function (d) { d.classList.remove('is-edge'); });
        return;
      }
      var start = Math.max(0, Math.min(n - MAXDOTS, i - Math.floor(MAXDOTS / 2)));
      var end = start + MAXDOTS - 1;
      var w = dots[0].offsetWidth || 14;
      strip.style.transform = 'translateX(' + (-start * w) + 'px)';
      dots.forEach(function (d, j) { d.classList.toggle('is-edge', (j === start && start > 0) || (j === end && end < n - 1)); });
    }
    if (mq.addEventListener) mq.addEventListener('change', function () { windowDots(cur); });
    function index() { var w = track.clientWidth || 1; return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))); }
    function set(i) {
      if (i !== cur) { taResetVideo(slides[cur]); cur = i; }
      dots.forEach(function (d, j) { var on = j === i; d.classList.toggle('is-active', on); if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      windowDots(i);
    root.classList.toggle('is-video-slide', !!(slides[i] && slides[i].querySelector('[data-ta-video]')));
    if (adaptive && slides[i] && slides[i].offsetHeight) track.style.height = slides[i].offsetHeight + 'px';
    }
    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var target = i * track.clientWidth;
      track.scrollTo({ left: target, behavior: 'smooth' });
      set(i);
      clearTimeout(root.__taFix);
      root.__taFix = setTimeout(function () {
        if (Math.abs(track.scrollLeft - target) > 2) { track.style.scrollBehavior = 'auto'; track.scrollLeft = target; track.style.scrollBehavior = ''; }
      }, 700);
    }
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(function () { set(index()); }, 80); }, { passive: true });
    track.addEventListener('scrollend', function () { clearTimeout(timer); set(index()); });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
    });
    window.addEventListener('resize', function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = cur * track.clientWidth; track.style.scrollBehavior = ''; if (root.__taFit) root.__taFit(); });
    set(0);
if (adaptive) { root.classList.add('is-fit'); root.__taFit(); track.addEventListener('scroll', fitSoon, { passive: true }); }
  }
  function taSliders(scope) { $$('[data-ta-slider]', scope || document).forEach(taSlider); $$('[data-ta-lightbox]', scope || document).forEach(taEnhanceBannerVideos); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { taSliders(); }); else taSliders();
  document.addEventListener('shopify:section:load', function (e) { taSliders(e.target); });

  /* ---- Banner media lightbox (course banner): play button opens the first video, image slides open the image ---- */
var taLb = null, taLbPrev = null;
function taEmbedUrl(u) {
if (!u) return '';
var y = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
if (y) return 'https://www.youtube.com/embed/' + y[1] + '?autoplay=1&rel=0&playsinline=1';
var v = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
if (v) return 'https://player.vimeo.com/video/' + v[1] + '?autoplay=1';
return u;
}
function taLbEl() {
if (taLb) return taLb;
taLb = document.createElement('div');
taLb.className = 'ta-lb';
taLb.setAttribute('role', 'dialog');
taLb.setAttribute('aria-modal', 'true');
taLb.setAttribute('aria-hidden', 'true');
taLb.setAttribute('aria-label', 'Media viewer');
taLb.innerHTML = '<div class="ta-lb__backdrop"></div><div class="ta-lb__stage" data-ta-lb-stage><div class="ta-lb__content"></div></div><button type="button" class="ta-lb__close" data-ta-lb-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
document.body.appendChild(taLb);
taLb.addEventListener('click', function (e) {
if (e.target.closest('[data-ta-lb-close]') || e.target.hasAttribute('data-ta-lb-stage') || e.target.classList.contains('ta-lb__backdrop')) taLbClose();
});
return taLb;
}
function taLbOpen(node, kind) {
var lb = taLbEl();
var box = lb.querySelector('.ta-lb__content');
box.className = 'ta-lb__content ta-lb__content--' + kind;
box.removeAttribute('style');
box.innerHTML = '';
box.appendChild(node);
taLbPrev = document.activeElement;
lb.classList.add('is-open');
lb.setAttribute('aria-hidden', 'false');
document.documentElement.classList.add('ta-lb-open');
var c = lb.querySelector('[data-ta-lb-close]');
try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); }
}
function taLbClose() {
if (!taLb || !taLb.classList.contains('is-open')) return;
taLb.classList.remove('is-open');
taLb.classList.remove('ta-lb--gallery');
taGal = null;
taLb.setAttribute('aria-hidden', 'true');
document.documentElement.classList.remove('ta-lb-open');
taLb.querySelector('.ta-lb__content').innerHTML = '';
if (taLbPrev && taLbPrev.focus) { try { taLbPrev.focus({ preventScroll: true }); } catch (err) {} }
taLbPrev = null;
}
function taLbVideo(el) {
if (!el) return false;
var node, tpl = el.querySelector('template[data-ta-native]');
if (tpl) {
var tmp = document.createElement('div');
tmp.innerHTML = tpl.innerHTML;
node = tmp.querySelector('video');
if (!node) return false;
node.setAttribute('playsinline', '');
node.setAttribute('controls', '');
node.setAttribute('autoplay', '');
} else {
var src = taEmbedUrl(el.getAttribute('data-embed'));
if (!src) return false;
node = document.createElement('iframe');
node.setAttribute('src', src);
node.setAttribute('title', 'Product video');
node.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
node.setAttribute('allowfullscreen', '');
}
taLbOpen(node, 'video');
var vr = parseFloat(el.getAttribute('data-ta-r')) || 16 / 9;
var vbox = taLb.querySelector('.ta-lb__content');
vbox.style.aspectRatio = String(vr);
vbox.style.width = 'min(1200px, 100%, calc((100vh - 144px) * ' + vr.toFixed(4) + '))';
vbox.style.width = 'min(1200px, 100%, calc((100dvh - 144px) * ' + vr.toFixed(4) + '))';
if (node.tagName === 'VIDEO') { var p = node.play(); if (p && p.catch) p.catch(function () {}); }
return true;
}
function taLbImage(slide) {
var src = slide.getAttribute('data-ta-lb-img');
if (!src) return false;
var img = document.createElement('img');
img.className = 'ta-lb__img';
img.alt = slide.getAttribute('data-ta-lb-alt') || '';
img.src = src;
taLbOpen(img, 'image');
return true;
}
function taLbHandle(e) {
var root = e.target.closest && e.target.closest('[data-ta-lightbox]');
if (!root) return;
if (e.target.closest('[data-ta-slider-prev],[data-ta-slider-next],[data-ta-slider-dot]')) return;
var hit = false;
if (e.target.closest('[data-ta-lb-video]')) hit = taLbVideo(root.querySelector('[data-ta-video]'));
else {
var v = e.target.closest('[data-ta-video]');
if (v) hit = taLbVideo(v);
else { var s = e.target.closest('[data-ta-lb-img]'); if (s) hit = taLbImage(s); }
}
if (hit) { e.preventDefault(); e.stopPropagation(); }
}
document.addEventListener('click', taLbHandle, true);

/* ---- Product gallery popup: Horizon Product information › Media › "Open media in a popup" uses the same popup as the course banner, plus thumbnails, arrows and videos ---- */
var taGal = null, taGalDown = null;
function taPickSrc(img, want) {
var best = '', bw = 0, big = img.currentSrc || img.src, bigW = 0;
(img.getAttribute('srcset') || '').split(',').forEach(function (part) {
var bits = part.trim().split(/\s+/), w = parseInt(bits[1], 10);
if (!bits[0] || !w) return;
if (w > bigW) { bigW = w; big = bits[0]; }
if (w >= want && (!bw || w < bw)) { bw = w; best = bits[0]; }
});
return best || big;
}
function taGalEmbed(src) {
try {
var u = new URL(src, location.href), p = u.searchParams;
p.set('autoplay', '1');
p.set('controls', '1');
if (/vimeo\.com$/.test(u.hostname)) { p.set('muted', '0'); p.delete('background'); }
if (/youtube(-nocookie)?\.com$/.test(u.hostname)) { p.set('mute', '0'); p.set('rel', '0'); p.set('playsinline', '1'); }
return u.toString();
} catch (err) { return src; }
}
function taGalItems(g) {
var dpr = window.devicePixelRatio || 1;
var fullW = Math.min(2560, Math.round(Math.min(window.innerWidth, 1400) * dpr));
var thumbW = Math.round(72 * dpr);
var items = [];
$$('.product-media-container', g).forEach(function (box) {
if (box.closest('dialog')) return;
var img = box.querySelector('img');
var it = { el: box, alt: (img && img.alt) || '', thumb: img ? taPickSrc(img, thumbW) : '' };
if (box.classList.contains('product-media-container--image')) {
if (!img) return;
it.type = 'image';
it.src = taPickSrc(img, fullW);
} else if (box.classList.contains('product-media-container--video') || box.classList.contains('product-media-container--external_video')) {
var tpl = box.querySelector('deferred-media template') || box.querySelector('template');
if (!tpl) return;
var tmp = document.createElement('div');
tmp.innerHTML = tpl.innerHTML;
var v = tmp.querySelector('video'), f = tmp.querySelector('iframe');
if (v) { it.type = 'video'; it.html = v.outerHTML; }
else if (f && f.getAttribute('src')) { it.type = 'embed'; it.src = taGalEmbed(f.getAttribute('src')); it.title = f.getAttribute('title') || it.alt; }
else return;
var pb = box.querySelector('.deferred-media__poster-button'), pm = box.querySelector('.product-media');
it.r = (pb && parseFloat(pb.style.getPropertyValue('--video-aspect-ratio'))) || (pm && parseFloat(pm.style.getPropertyValue('--ratio'))) || 16 / 9;
} else return;
items.push(it);
});
return items;
}
function taGalNode(it) {
var node, tmp;
if (it.type === 'image') {
node = document.createElement('img');
node.className = 'ta-lb__img';
node.alt = it.alt;
node.src = it.src;
} else if (it.type === 'embed') {
node = document.createElement('iframe');
node.setAttribute('src', it.src);
node.setAttribute('title', it.title || 'Product video');
node.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
node.setAttribute('allowfullscreen', '');
} else {
tmp = document.createElement('div');
tmp.innerHTML = it.html;
node = tmp.querySelector('video');
node.removeAttribute('muted');
node.muted = false;
node.removeAttribute('loop');
node.setAttribute('controls', '');
node.setAttribute('playsinline', '');
node.setAttribute('autoplay', '');
}
return node;
}
function taGalChrome() {
var lb = taLbEl();
if (lb.__taGal) return lb;
lb.__taGal = true;
var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>';
var wrap = document.createElement('div');
wrap.innerHTML = '<div class="ta-lb__count" aria-live="polite"></div>' +
'<button type="button" class="ta-lb__nav ta-lb__nav--prev" data-ta-lb-step="-1" aria-label="Previous">' + arrow + '</button>' +
'<button type="button" class="ta-lb__nav ta-lb__nav--next" data-ta-lb-step="1" aria-label="Next">' + arrow + '</button>' +
'<div class="ta-lb__thumbs" role="tablist" aria-label="Product media"></div>';
while (wrap.firstChild) lb.appendChild(wrap.firstChild);
lb.addEventListener('click', function (e) {
if (!taGal) return;
if (lb.__taSwipe && Date.now() - lb.__taSwipe < 400) { e.preventDefault(); e.stopPropagation(); return; }
var s = e.target.closest('[data-ta-lb-step]'), t = e.target.closest('[data-ta-lb-go]');
if (s) { e.stopPropagation(); taGalShow(taGal.i + parseInt(s.getAttribute('data-ta-lb-step'), 10)); }
else if (t) { e.stopPropagation(); taGalShow(parseInt(t.getAttribute('data-ta-lb-go'), 10)); }
}, true);
var sx = 0, sy = 0, on = false;
lb.addEventListener('touchstart', function (e) {
on = !!(taGal && taGal.items.length > 1 && e.touches.length === 1 && !e.target.closest('.ta-lb__thumbs'));
if (on) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
}, { passive: true });
lb.addEventListener('touchend', function (e) {
if (!on || !taGal) return;
on = false;
var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { lb.__taSwipe = Date.now(); taGalShow(taGal.i + (dx < 0 ? 1 : -1)); }
}, { passive: true });
return lb;
}
function taGalShow(i) {
if (!taGal || !taLb) return;
var items = taGal.items, n = items.length;
i = ((i % n) + n) % n;
taGal.i = i;
var it = items[i], node = taGalNode(it);
var box = taLb.querySelector('.ta-lb__content');
box.className = 'ta-lb__content ta-lb__content--' + (it.type === 'image' ? 'image' : 'video');
box.removeAttribute('style');
box.innerHTML = '';
box.appendChild(node);
if (it.type !== 'image') {
var r = it.r.toFixed(4);
box.style.aspectRatio = r;
box.style.width = 'min(1200px, 100%, calc((100vh - var(--ta-lb-reserve, 144px)) * ' + r + '))';
box.style.width = 'min(1200px, 100%, calc((100dvh - var(--ta-lb-reserve, 144px)) * ' + r + '))';
}
if (node.tagName === 'VIDEO') { var p = node.play(); if (p && p.catch) p.catch(function () {}); }
taLb.querySelector('.ta-lb__count').textContent = (i + 1) + ' / ' + n;
var strip = taLb.querySelector('.ta-lb__thumbs');
$$('[data-ta-lb-go]', strip).forEach(function (b, j) {
var cur = j === i;
b.classList.toggle('is-active', cur);
b.setAttribute('aria-selected', cur ? 'true' : 'false');
if (cur && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: Math.max(0, b.offsetLeft - (strip.clientWidth - b.offsetWidth) / 2), behavior: 'smooth' });
});
[i - 1, i + 1].forEach(function (j) {
var nb = items[((j % n) + n) % n];
if (nb && nb.type === 'image' && !nb.pre) { nb.pre = new Image(); nb.pre.src = nb.src; }
});
}
function taGalOpen(items, i) {
var lb = taGalChrome();
var strip = lb.querySelector('.ta-lb__thumbs');
var play = '<span class="ta-lb__thumb-play" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg></span>';
strip.innerHTML = '';
items.forEach(function (it, j) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'ta-lb__thumb';
b.setAttribute('role', 'tab');
b.setAttribute('data-ta-lb-go', String(j));
b.setAttribute('aria-label', (it.type === 'image' ? 'Image ' : 'Video ') + (j + 1) + ' of ' + items.length);
var im = document.createElement('img');
im.src = it.thumb;
im.alt = '';
b.appendChild(im);
if (it.type !== 'image') b.insertAdjacentHTML('beforeend', play);
strip.appendChild(b);
});
lb.classList.toggle('ta-lb--gallery', items.length > 1);
taLbOpen(document.createElement('span'), 'image');
taGal = { items: items, i: i };
taGalShow(i);
}
document.addEventListener('pointerdown', function (e) {
taGalDown = e.target.closest && e.target.closest('[data-ta-gallery-popup]') ? { x: e.clientX, y: e.clientY } : null;
}, true);
function taGalleryPopup(e) {
var g = e.target.closest && e.target.closest('[data-ta-gallery-popup]');
if (!g) return;
var down = taGalDown;
taGalDown = null;
if (e.target.closest('a, slideshow-arrows, slideshow-controls, .slideshow-controls, iframe, video, product-model, model-viewer')) return;
if (e.detail && down && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 10) return;
var box = e.target.closest('.product-media-container');
if (!box) return;
var items = taGalItems(g), i = -1;
items.forEach(function (it, j) { if (it.el === box) i = j; });
if (i < 0) return;
e.preventDefault();
e.stopPropagation();
$$('deferred-media', g).forEach(function (d) { try { if (d.pauseMedia) d.pauseMedia(); } catch (err) {} });
taGalOpen(items, i);
}
/* window capture runs before Horizon's own document-level click handlers, so the inline video does not load behind the popup */
window.addEventListener('click', taGalleryPopup, true);
document.addEventListener('keydown', function (e) {
if (taLb && taLb.classList.contains('is-open')) {
if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); taLbClose(); }
else if (taGal && taGal.items.length > 1 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { e.preventDefault(); e.stopPropagation(); taGalShow(taGal.i + (e.key === 'ArrowRight' ? 1 : -1)); }
return;
}
if (e.key !== 'Enter' && e.key !== ' ') return;
var t = e.target;
if (!t || !t.hasAttribute || !t.closest('[data-ta-lightbox]')) return;
if (t.hasAttribute('data-ta-video') || t.hasAttribute('data-ta-lb-img')) taLbHandle(e);
}, true);

/* ---- Mobile menu drawer ---- */
  function taFocusLater(el) {
    if (!el) return;
    setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); } }, 320);
  }
  var taMenu = {
    el: function () { return $('[data-ta-mdrawer]'); },
    position: function () {
      var d = this.el(); var bar = $('.ta-header-bar'); if (!d || !bar) return;
      var r = bar.getBoundingClientRect();
      d.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
    },
    open: function () {
      var d = this.el(); if (!d) return;
      var bar = $('.ta-header-bar');
      if (bar && bar.getBoundingClientRect().top < 0) window.scrollTo(0, 0);
      this.position();
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ta-mdrawer-open');
      $$('[data-ta-menu-toggle]').forEach(function (b) { b.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); });
    },
    close: function () {
      var d = this.el(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      $$('.ta-mdrawer__sub.is-open, [data-ta-loc-panel].is-open', d).forEach(function (s) { s.classList.remove('is-open'); });
      $$('[data-ta-sub-open], [data-ta-loc-open]', d).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.documentElement.classList.remove('ta-mdrawer-open');
      $$('[data-ta-menu-toggle]').forEach(function (b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
    },
    isOpen: function () { var d = this.el(); return !!(d && d.classList.contains('is-open')); },
    toggle: function () { this.isOpen() ? this.close() : this.open(); }
  };
  window.addEventListener('resize', function () {
    if (!taMenu.isOpen()) return;
    if (window.innerWidth > 979) taMenu.close(); else taMenu.position();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && taMenu.isOpen()) taMenu.close(); });

  /* ---- Cart drawer ---- */
  var money = function (cents) {
    var fmt = (window.TA_MONEY_FORMAT || '${{amount}}');
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount2 = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount).replace(/\{\{\s*amount\s*\}\}/, amount2);
  };

  function openCart() { document.documentElement.classList.add('ta-cart-open'); }
  function closeCart() { document.documentElement.classList.remove('ta-cart-open'); }

  function renderCart(cart) {
    $$('.ta-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    var list = $('#ta-cart-items');
    if (!list) return;
    var empty = $('#ta-cart-empty');
    if (empty) empty.style.display = cart.items.length ? 'none' : 'block';
    list.innerHTML = cart.items.map(function (it) {
      return '<div style="display:flex;gap:14px;background:var(--ta-bg);border:1px solid var(--ta-line);padding:14px;border-radius:var(--ta-radius-sm)">' +
        (it.image ? '<img src="' + it.image + '&width=148" alt="" style="width:74px;height:74px;object-fit:cover;flex-shrink:0" onerror="this.style.display=\'none\'">' : '') +
        '<div style="flex:1"><div style="font-size:var(--ta-text-compact);font-weight:600;line-height:1.25;color:var(--ta-ink)">' + it.product_title + '</div>' +
        '<div style="font-size:var(--ta-text-label);color:var(--ta-x-8c8577);margin-top:5px">' + (it.variant_title || '') + '</div>' +
        '<div style="display:flex;align-items:center;gap:12px;margin-top:10px">' +
        '<div style="display:flex;align-items:center;border:1px solid var(--ta-line);border-radius:var(--ta-radius-sm)">' +
        '<button class="ta-qty-btn" data-ta-qty="-1" data-key="' + it.key + '" style="background:var(--ta-bg);border:none;width:26px;height:26px;cursor:pointer;color:var(--ta-muted);font-size:var(--ta-text-small)">&minus;</button>' +
        '<span style="font-size:var(--ta-text-caption);font-weight:600;width:24px;text-align:center;display:inline-block">' + it.quantity + '</span>' +
        '<button class="ta-qty-btn" data-ta-qty="1" data-key="' + it.key + '" style="background:var(--ta-bg);border:none;width:26px;height:26px;cursor:pointer;color:var(--ta-muted);font-size:var(--ta-text-small)">+</button>' +
        '</div><span style="font-size:var(--ta-text-small);font-weight:700;color:var(--ta-navy);margin-left:auto">' + money(it.final_line_price) + '</span>' +
        '</div></div></div>';
    }).join('');
    $$('.ta-cart-subtotal').forEach(function (el) { el.textContent = money(cart.items_subtotal_price); });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); }).then(function () { openCart(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var add = e.target.closest('[data-ta-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-ta-add'), Number(add.getAttribute('data-ta-qty') || 1)); return; }
    if (e.target.closest('[data-ta-cart-open]')) { e.preventDefault(); refreshCart(); openCart(); return; }
    if (e.target.closest('[data-ta-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var qb = e.target.closest('[data-ta-qty][data-key]');
    if (qb) {
      e.preventDefault();
      var row = qb.parentElement.querySelector('span');
      var current = Number(row.textContent);
      var next = current + Number(qb.getAttribute('data-ta-qty'));
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qb.getAttribute('data-key'), quantity: Math.max(0, next) })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
    var mt = e.target.closest('[data-ta-menu-toggle]');
    if (mt) { e.preventDefault(); taMenu.toggle(); return; }
    var so = e.target.closest('[data-ta-sub-open]');
    if (so) {
      e.preventDefault();
      var sub = $('[data-ta-sub="' + so.getAttribute('data-ta-sub-open') + '"]');
      if (sub) { sub.classList.add('is-open'); sub.scrollTop = 0; so.setAttribute('aria-expanded', 'true'); var bk = $('[data-ta-sub-back]', sub); taFocusLater(bk); }
      return;
    }
    var sb = e.target.closest('[data-ta-sub-back]');
    if (sb) {
      e.preventDefault();
      var subEl = sb.closest('.ta-mdrawer__sub');
      if (subEl) { subEl.classList.remove('is-open'); var op = $('[data-ta-sub-open="' + subEl.getAttribute('data-ta-sub') + '"]'); if (op) { op.setAttribute('aria-expanded', 'false'); taFocusLater(op); } }
      return;
    }
    var lo = e.target.closest('[data-ta-loc-open]');
    if (lo) { e.preventDefault(); var lp = $('[data-ta-loc-panel]'); if (lp) { lp.classList.add('is-open'); lp.scrollTop = 0; lo.setAttribute('aria-expanded', 'true'); var lc0 = $('[data-ta-loc-close]', lp); taFocusLater(lc0); } return; }
    var lc = e.target.closest('[data-ta-loc-close]');
    if (lc) { e.preventDefault(); var lp2 = $('[data-ta-loc-panel]'); if (lp2) lp2.classList.remove('is-open'); var lob = $('[data-ta-loc-open]'); if (lob) { lob.setAttribute('aria-expanded', 'false'); taFocusLater(lob); } return; }
    var ct = e.target.closest('[data-ta-country-toggle]');
    if (ct) { e.preventDefault(); ct.closest('.ta-country').classList.toggle('is-open'); return; }
    if (!e.target.closest('.ta-country')) { $$('.ta-country.is-open').forEach(function (c) { c.classList.remove('is-open'); }); }
  });

  /* ---- Hero slideshow ---- */
  $$('.ta-hero-slides').forEach(function (wrap) {
    var slides = $$('.ta-hero-slide', wrap);
    var dots = $$('.ta-hero-dot', wrap.parentElement);
    if (slides.length < 2) return;
    var idx = 0, timer;
    function show(i) {
      idx = i % slides.length;
      slides.forEach(function (s, j) { s.style.opacity = j === idx ? 1 : 0; });
      dots.forEach(function (d, j) { d.firstElementChild.style.background = 'color-mix(in srgb, var(--ta-on-dark) ' + (j === idx ? '95%' : '35%') + ', transparent)'; });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, 5000); }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); start(); }); });
    show(0); start();
  });

  /* ---- Review carousel ---- */
  $$('.ta-carousel').forEach(function (car) {
    var track = $('.ta-carousel-track', car);
    var pages = $$('.ta-carousel-page', car);
    var dots = $$('.ta-carousel-dot', car);
    function show(i) {
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (d, j) { d.style.background = j === i ? 'var(--ta-navy)' : 'var(--ta-x-d7d2c8)'; });
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    show(0);
  });

  /* ---- Reviews page filters ---- */
  $$('.ta-reviews-filter').forEach(function (bar) {
    var root = bar.closest('.ta-reviews-root');
    var buttons = $$('button[data-filter]', bar);
    var cards = $$('[data-review-tag]', root);
    var countEl = $('.ta-filter-count', root);
    function apply(f) {
      var n = 0;
      cards.forEach(function (c) {
        var tag = c.getAttribute('data-review-tag');
        var rating = Number(c.getAttribute('data-rating') || 5);
        var show = f === 'all' || (f === 'critical' ? rating <= 4 : tag === f);
        c.classList.toggle('ta-review-hidden', !show);
        if (show) n++;
      });
      if (countEl) countEl.textContent = n + ' shown';
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-filter') === f;
        b.style.background = active ? 'var(--ta-navy)' : 'var(--ta-bg)';
        b.style.borderColor = active ? 'var(--ta-navy)' : 'var(--ta-line)';
        b.style.color = active ? 'var(--ta-on-dark)' : 'var(--ta-x-3b4a58)';
      });
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); }); });
    apply('all');
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
  if (document.readyState !== 'loading') refreshCart();
})();


/* Waiting list: sold-out products link to the product page's waiting-list form (#klaviyo-waitlist-section).
   If a product page has no waiting-list section, the button falls back to the contact page.
   Arriving with #klaviyo-waitlist-section (or any #anchor), re-align once images/videos above have loaded. */
(function () {
  var WL = 'klaviyo-waitlist-section';
  function fixLinks() {
    if (document.getElementById(WL)) return;
    document.querySelectorAll('.ta-btn--waitlist[href="#' + WL + '"]').forEach(function (a) { a.setAttribute('href', '/pages/contact'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixLinks); else fixLinks();
  var hash = location.hash ? decodeURIComponent(location.hash.slice(1)) : '';
  if (!hash || !/^[\w-]+$/.test(hash)) return;
  var moved = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, function () { moved = true; }, { once: true, passive: true }); });
  function align() {
    if (moved) return;
    var t = document.getElementById(hash); if (!t) return;
    /* on desktop the page scrolls inside .page-wrapper, on mobile the window scrolls */
    var top = t.getBoundingClientRect().top; if (Math.abs(top) <= 4) return;
    var sc = null; for (var p = t.parentElement; p; p = p.parentElement) { var o = getComputedStyle(p).overflowY; if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight + 1) { sc = p; break; } }
    if (sc) sc.scrollTo({ top: sc.scrollTop + top - sc.getBoundingClientRect().top, behavior: 'instant' });
    else window.scrollTo({ top: window.pageYOffset + top, behavior: 'instant' });
  }
  function start() { align(); setTimeout(align, 400); setTimeout(align, 1200); setTimeout(align, 2500); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();

/* ---- TA reviews (Reviews metaobject): carousel arrows, "Read more" on cards, "Load more" on the Reviews page ---- */
(function () {
  if (window.__taReviewsJs) return;
  window.__taReviewsJs = true;
  function taRvCheck(card) {
    var body = card.querySelector('[data-ta-rv-body]');
    var btn = card.querySelector('[data-ta-rv-more]');
    var link = card.querySelector('[data-ta-rv-link]');
    if (!body || card.hidden || card.classList.contains('is-open')) return;
    var cut = body.scrollHeight > body.clientHeight + 2;
    /* Reviews page: "Read more" links to the full review only when the card text is cut */
    if (link) link.hidden = !cut;
    if (!btn) return;
    var reply = card.querySelector('[data-ta-rv-reply]');
    btn.hidden = !(cut || reply);
    if (!cut && reply) btn.setAttribute('data-more', btn.getAttribute('data-reply') || 'See reply');
    btn.textContent = btn.getAttribute('data-more');
  }
  function taRvSetup(root) {
    root.querySelectorAll('[data-ta-rv]').forEach(function (card) {
      if (!card.__taRv) {
        card.__taRv = true;
        var btn = card.querySelector('[data-ta-rv-more]');
        if (btn) btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          var reply = card.querySelector('[data-ta-rv-reply]');
          if (reply) reply.hidden = !open;
          btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      taRvCheck(card);
    });
  }
  function taRcSetup(el) {
    if (el.__taRc) return;
    el.__taRc = true;
    var track = el.querySelector('[data-ta-rc-track]');
    var prev = el.querySelector('[data-ta-rc-prev]');
    var next = el.querySelector('[data-ta-rc-next]');
    if (!track) return;
    function step() {
      var slide = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      el.classList.toggle('ta-rc--static', max <= 2);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function taRgSetup(el) {
    if (el.__taRg) return;
    el.__taRg = true;
    var btn = el.querySelector('[data-ta-rg-more]');
    var stepN = parseInt(el.getAttribute('data-step'), 10) || 12;
    var grid = el.querySelector('[data-ta-rg-grid]');
    if (grid) {
      /* newest first: entries come in the order they were created, so sort by the review date */
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ta-rv]'));
      var sorted = cards.slice().sort(function (x, y) { return (y.getAttribute('data-date') || '').localeCompare(x.getAttribute('data-date') || ''); });
      if (sorted.some(function (c, i) { return c !== cards[i]; })) {
        sorted.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= stepN; });
      }
    }
    if (!btn) return;
    btn.addEventListener('click', function () {
      var hiddenCards = el.querySelectorAll('[data-ta-rv][hidden]');
      for (var i = 0; i < hiddenCards.length && i < stepN; i++) {
        hiddenCards[i].hidden = false;
        taRvCheck(hiddenCards[i]);
      }
      if (hiddenCards.length <= stepN) btn.parentNode.hidden = true;
    });
  }
  function taReviewsInit(root) {
    root.querySelectorAll('[data-ta-rc]').forEach(taRcSetup);
    root.querySelectorAll('[data-ta-rg]').forEach(taRgSetup);
    taRvSetup(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { taReviewsInit(document); });
  else taReviewsInit(document);
  window.addEventListener('load', function () { taRvSetup(document); });
  var taRvResize;
  window.addEventListener('resize', function () { clearTimeout(taRvResize); taRvResize = setTimeout(function () { taRvSetup(document); }, 200); });
  document.addEventListener('shopify:section:load', function (e) { taReviewsInit(e.target); });
})();
